<template>
  <div class="br-product-slide">
    <div class="br-product-slide__header">
      <div class="br-lead br-lead--center">
        <div class="br-lead__wrapper">
          <h1>Visualizing team <span>collaboration</span> </h1>
          <h2>Strategically congregate groups of employees, divisions, or teams around crucial discussion topics. Allow the free form exchange of ideas and resources!</h2>
        </div>
      </div>
      <div class="br-product-slide__menu">
        <div
          v-if="step"
          class="navlinks">
          <div class="navlinks__item">
            <a
              href=""
              :class="{ 'navlinks__link--active': step.group === 'watercooler', 'navlinks__link--pulsate': step.className === 'br-product-slide__process-a' }"
              class="navlinks__link"
              @click.prevent="setActiveGuide(1)">
              <span class="navlinks__icon">
                <i class="icon icon-multiple-11"/>
              </span>
              <span class="navlinks__label">Watercooler</span>
            </a>
          </div>
          <div class="navlinks__item">
            <a
              href=""
              :class="{ 'navlinks__link--active': step.group === 'discussion-group' }"
              class="navlinks__link"
              @click.prevent="setActiveGuide(3)">
              <span class="navlinks__icon">
                <i class="icon icon-questionnaire"/>
              </span>
              <span class="navlinks__label">Discussion Topics</span>
            </a>
          </div>
          <div class="navlinks__item">
            <a
              href=""
              :class="{ 'navlinks__link--active': step.group === 'ideation-board' }"
              class="navlinks__link"
              @click.prevent="setActiveGuide(5)">
              <span class="navlinks__icon">
                <i class="icon icon-bulb-62"/>
              </span>
              <span class="navlinks__label">Ideation Board</span>
            </a>
          </div>
        </div>
        <div class="br-product-slide__switcher">
          <button
            data-prod-slider-index="1"
            class="button">
            <div class="button__icon button__icon--pulsate">
              <i class="icon icon-arrow-right-2"/>
            </div>
            <div class="button__text">
              <div class="text-group">
                <span class="text">Next Lesson</span>
                <span class="text text--muted">Exploration & Testing</span>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="br-product-slide__main">
      <div class="br-product-slide__stage">
        <div
          v-if="step"
          class="br-product-slide__demo">
          <Dialog
            :step="step"
            @next="setActiveGuide(++active)"
            @prev="setActiveGuide(--active)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from './WatercoolerFeatureDialog'
import { gsap as Gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import $ from 'jquery'

export default {
  components: {
    Dialog
  },
  data: () => ({
    gsapTimeline: null,
    steps: [{
      image: '/img/hero/zenvoy-hero-watercooler-a.png',
      className: 'br-product-slide__process-a',
      components: [{
        image: '/img/hero/zenvoy-hero-watercooler-post-a.png',
        className: 'br-product-slide__process-a__post-a'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-post-b.png',
        className: 'br-product-slide__process-a__post-b'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-post-c.png',
        className: 'br-product-slide__process-a__post-c'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-post-d.png',
        className: 'br-product-slide__process-a__post-d'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-post-e.png',
        className: 'br-product-slide__process-a__post-e'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-post-f.png',
        className: 'br-product-slide__process-a__post-f'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-post-g.png',
        className: 'br-product-slide__process-a__post-g'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-post-h.png',
        className: 'br-product-slide__process-a__post-h'
      }],
      init (timeline) {
       timeline
          .from('.br-product-slide__process-a__post-a', { delay: 3, y: 30, duration: 0.2, autoAlpha: 0 })
          .from('.br-product-slide__process-a__post-b', { y: 30, duration: 0.2, autoAlpha: 0 })
          .from('.br-product-slide__process-a__post-c', { y: 30, duration: 0.2, autoAlpha: 0 })
          .from('.br-product-slide__process-a__post-d', { y: 30, duration: 0.2, autoAlpha: 0 })
          .from('.br-product-slide__process-a__post-e', { y: 30, duration: 0.2, autoAlpha: 0 })
          .from('.br-product-slide__process-a__post-f', { y: 30, duration: 0.2, autoAlpha: 0 })
          .from('.br-product-slide__process-a__post-g', { y: 30, duration: 0.2, autoAlpha: 0 })
          .from('.br-product-slide__process-a__post-h', { y: 30, duration: 0.2, autoAlpha: 0 })

        ScrollTrigger.create({
          animation: timeline,
          trigger: $('.br-product-slide__process-a'),
          start: 'top 100%',
          toggleClass: 'animate-post',
          onEnter: () => timeline.play()
        })
      }
    }, {
      title: 'The Watercooler',
      className: 'br-product-slide__process-b',
      description: 'Each Watercooler session automatically arranges up to 8 compatible employees using a matching algorithm designed, (by you) specifically for your company’s engagement needs. ',
      image: '/img/hero/zenvoy-hero-watercooler-b.png',
      group: 'watercooler',
      icon: 'icon-privacy-settings',
      overlayClass: 'br-product-slide__process-b__overlay',
      components: [{
        image: '/img/hero/zenvoy-hero-watercooler-process-b-user-a.png',
        className: 'br-product-slide__process-b__user-a'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-process-b-user-b.png',
        className: 'br-product-slide__process-b__user-b'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-process-b-user-c.png',
        className: 'br-product-slide__process-b__user-c'
      }],
      init (timeline) {
        timeline
          .fromTo('.br-product-slide__process-b__overlay', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-b__user-a', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-b__user-b', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-b__user-c', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-b__dialog', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
      }
    }, {
      title: 'The People',
      className: 'br-product-slide__process-c',
      description: 'Before each Watercooler, your arranged colleagues will have an opportunity learn more about each other’s proficiencies, skills and services.',
      image: '/img/hero/zenvoy-hero-watercooler-b.png',
      group: 'watercooler',
      icon: 'icon-privacy-settings',
      dialogClassName: 'br-product-slide__demo__steps--left-head',
      overlayClass: 'br-product-slide__process-c__overlay',
      components: [{
        image: '/img/hero/zenvoy-hero-watercooler-process-c-component-a.png',
        className: 'br-product-slide__process-c__component-a'
      }],
      init (timeline) {
        timeline
          .fromTo('.br-product-slide__process-c__overlay', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-c__component-a', { x: -30, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
          .fromTo('.br-product-slide__process-c__dialog', { x: -30, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
      }
    }, {
      title: 'The Prompt',
      className: 'br-product-slide__process-d',
      description: 'Each Watercooler discussion revolves around a prompt question. This “topic,” provides a framework for the group’s engagement, learning and sharing. Choose topics that best support the meaningful connection and dialogue among your employees.    ',
      image: '/img/hero/zenvoy-hero-watercooler-b.png',
      group: 'discussion-group',
      icon: 'icon-privacy-settings',
      dialogClassName: 'br-product-slide__demo__steps',
      overlayClass: 'br-product-slide__process-d__overlay',
      components: [{
        image: '/img/hero/zenvoy-hero-watercooler-process-d-component-a.png',
        className: 'br-product-slide__process-d__component-a'
      }],
      init (timeline) {
        timeline
          .fromTo('.br-product-slide__process-d__overlay', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-d__component-a', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-d__dialog', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
      }
    }, {
      title: 'The Cohort Leader',
      className: 'br-product-slide__process-e',
      description: 'Each Watercooler is moderated by a single Cohort Leader. This individual spurs conversation, maintains order and organizes the group’s ideation board. ',
      image: '/img/hero/zenvoy-hero-watercooler-b.png',
      group: 'discussion-group',
      icon: 'icon-privacy-settings',
      dialogClassName: 'br-product-slide__demo__steps--left-head',
      overlayClass: 'br-product-slide__process-e__overlay',
      components: [{
        image: '/img/hero/zenvoy-hero-watercooler-process-e-user-a.png',
        className: 'br-product-slide__process-e__user-a'
      }],
      init (timeline) {
        timeline
          .fromTo('.br-product-slide__process-e__overlay', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-e__user-a', { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-e__dialog', { x: -30, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
      }
    }, {
      title: 'Ideation Quadrants',
      className: 'br-product-slide__process-f',
      description: 'The ideation board is separated into four zones: Resources, Ideas, Tips, Questions.',
      image: '/img/hero/zenvoy-hero-watercooler-c.png',
      group: 'ideation-board',
      icon: 'icon-privacy-settings',
      dialogClassName: 'br-product-slide__demo__steps--left-head',
      overlayClass: '',
      components: [{
        image: '/img/hero/zenvoy-hero-watercooler-process-f-component-a.png',
        className: 'br-product-slide__process-f__component-a'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-process-f-component-b.png',
        className: 'br-product-slide__process-f__component-b'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-process-f-component-c.png',
        className: 'br-product-slide__process-f__component-c'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-process-f-component-d.png',
        className: 'br-product-slide__process-f__component-d'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-process-f-component-e.png',
        className: 'br-product-slide__process-f__component-e'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-process-f-component-f.png',
        className: 'br-product-slide__process-f__component-f'
      }, {
        image: '/img/hero/zenvoy-hero-watercooler-process-f-component-g.png',
        className: 'br-product-slide__process-f__component-g'
      }],
      init (timeline) {
        timeline
          .fromTo('.br-product-slide__process-f__component-a', 0.1, { autoAlpha: 1 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-f__component-b', 1, { delay: 1, y: 0 }, { delay: 1, y: -159 })
          .fromTo('.br-product-slide__process-f__component-c', 0.2, { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-f__component-e', 0.5, { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-f__component-e-label', 0.3, { y: 10, x: -10, autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1 })
          .to('.br-product-slide__process-f__component-e-label', 0.3, { delay: 1, y: 0, x: 0, autoAlpha: 0 })
          .to('.br-product-slide__process-f__component-e', 0.5, { delay: 1, autoAlpha: 0 })
          .fromTo('.br-product-slide__process-f__component-g', 0.5, { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-f__component-g-label', 0.3, { y: -10, x: -10, autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1 })
          .to('.br-product-slide__process-f__component-g-label', 0.3, { delay: 1, y: 0, x: 0, autoAlpha: 0 })
          .to('.br-product-slide__process-f__component-g', 0.5, { autoAlpha: 0 })
          .fromTo('.br-product-slide__process-f__component-f', 0.5, { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-f__component-f-label', 0.3, { y: -10, x: 10, autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1 })
          .to('.br-product-slide__process-f__component-f-label', 0.3, { delay: 1, y: 0, x: 0, autoAlpha: 0 })
          .to('.br-product-slide__process-f__component-f', 0.5, { autoAlpha: 0 })
          .fromTo('.br-product-slide__process-f__component-d', 0.5, { autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-f__component-d-label', 0.3, { y: 10, x: 10, autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1 })
          .to('.br-product-slide__process-f__component-d-label', 0.3, { delay: 1, y: 0, x: 0, autoAlpha: 0 })
          .fromTo('.br-product-slide__process-f__dialog', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1 })
      }
    }, {
      title: 'Watercooler Sessions',
      className: 'br-product-slide__process-g',
      description: 'Easily navigate between multiple groups discussions at once. ',
      image: '/img/hero/zenvoy-hero-watercooler-c.png',
      group: 'ideation-board',
      icon: 'icon-privacy-settings',
      dialogClassName: 'br-product-slide__demo__steps--left-head',
      overlayClass: '',
      components: [{
        image: '/img/hero/zenvoy-hero-watercooler-process-g-component-d.png',
        className: 'br-product-slide__process-g__component-d'
      }],
      init (timeline) {
        timeline
          .fromTo('.br-product-slide__process-g__tab-marker', { delay: 1, autoAlpha: 0 }, { autoAlpha: 1 })
          .fromTo('.br-product-slide__process-g__component-d', { delay: 1, x: -30, autoAlpha: 0 }, { delay: 1, x: 0, autoAlpha: 1 })
          .fromTo('.br-product-slide__process-g__dialog', { x: -30, autoAlpha: 0 }, { x: 0, autoAlpha: 1 })
      }
    }],
    step: null,
    active: 0
  }),
  mounted () {
    Gsap.registerPlugin(ScrollTrigger)

    this.gsapTimeline = Gsap.timeline({ paused: true })

    this.step = this.steps[this.active]

    this.$nextTick(() => {
      this.step.init(this.gsapTimeline)
    })
  },
  methods: {
    setActiveGuide (index) {
      if (this.steps[index]) {
        this.active = index
        this.step = this.steps[index]

        this.$nextTick(() => {
          this.step.init(this.gsapTimeline)
        })
      }
    }
  }
}
</script>
